import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import * as orderServices from "../../services/order.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import CustomRangepicker from "../../common/rangepicker";
import $ from "jquery";
import {
  formateDateWithMonth,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

const OrderList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [datalength, setDataLength] = useState(0);
  const [itemperpage] = useState(10);
  const [page, setPage] = useState(1);
  const [sorting, setSorting] = useState({});
  const [loader, setLoader] = useState(true);
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [tab, setTab] = useState("all");
  const [resetdate, setResetDate] = useState(false);

  const breadcrumbs = [
    { title: "Dashboard", url: "/admin/dashboard" },
    { title: "Orders", url: "" },
  ];

  const tabs = [
    { key: "all", label: "All" },
    { key: "placed", label: "Placed" },
    { key: "processing", label: "Processing" },
    { key: "shipped", label: "Shipped" },
    { key: "delivered", label: "Delivered" },
    { key: "cancelled", label: "Cancelled" },
    { key: "Return Requests", label: "Return Requests" },
    { key: "returned", label: "Returned" },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(true);
      const formData = new FormData();
      formData.append("page", page);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(search));
      formData.append("global_search", globalsearch);
      formData.append("tab", tab);

      orderServices
        .OrderList(formData)
        .then((res) => {
          setList(res.data.list || []);
          setDataLength(res.data.total_records || 0);
          setPage(res.data.page || 1);
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
        });
    }, 300);

    return () => clearTimeout(timer);
  }, [page, sorting, search, globalsearch, tab, resetdate]);

  const handleSort = (column) => {
    let order = sorting.column === column && sorting.order === 1 ? -1 : 1;
    setSorting({ column, order });
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  console.log("serch ", search);

  const resetFilter = () => {
    setGlobalSearch("");
    setSearch({});
    setResetDate(!resetdate);
  };

  const updateStatus = (id, status) => {
    let swalOptions = {
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: `Change order status to "${status}"?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
    };

    if (status === "Cancelled" || status === "return_rejected") {
      swalOptions.input = "textarea";
      swalOptions.inputPlaceholder = `Enter ${status === "Cancelled" ? "cancellation" : "rejection"} reason (required)`;
      swalOptions.inputValidator = (value) => {
        if (!value || value.trim() === "") {
          return `Please enter a valid ${status === "Cancelled" ? "cancellation" : "rejection"} reason!`;
        }
      };
    }

    Swal.fire(swalOptions).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          id: id,
          status: status,
        };
        if (status === "Cancelled") {
          payload.admin_cancel_reason = result.value;
        } else if (status === "return_rejected") {
          payload.admin_cancel_reason = result.value;
        }

        orderServices
          .UpdateOrderStatus(payload)
          .then((response) => {
            if (response && response.success) {
              Swal.fire({
                icon: "success",
                text: response.message || "Status updated successfully!",
                ...SWAL_SETTINGS,
              });
              setResetDate(!resetdate); // Refresh list
            } else {
              // Handle validation or server errors
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.error("Update status error:", error);
            Swal.fire({
              icon: "error",
              text: "Something went wrong. Please try again.",
              ...SWAL_SETTINGS,
            });
          });
      }
    });
  };

  const manageReturn = (orderId, itemId, action) => {
    const actionText = {
      approve: "Approve",
      reject: "Reject",
      process: "Process Refund",
    }[action];

    Swal.fire({
      customClass: "swal-wide",
      title: "Are you sure?",
      text: `${actionText} this return request?`,
      icon: "question",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: "Yes, " + actionText,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("order_id", orderId);
        formData.append("item_id", itemId);
        formData.append("action", action);

        orderServices
          .ManageReturn(formData)
          .then((response) => {
            if (response && response.success) {
              Swal.fire({
                icon: "success",
                text: response.message || "Return updated successfully!",
                ...SWAL_SETTINGS,
              });
              setResetDate(!resetdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              text: "Operation failed. Please try again.",
              ...SWAL_SETTINGS,
            });
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Orders</h6>
              <div className="d-flex align-items-center">
                <input
                  type="search"
                  className="form-control me-3"
                  placeholder="Search..."
                  value={globalsearch}
                  onChange={(e) => setGlobalSearch(e.target.value)}
                />
                {/* <CustomRangepicker
                  GetDateRange={(e) => prepareSearch("createdAt", e)}
                  resetdate={resetdate}
                /> */}
                <button className="btn btn-warning ms-2" onClick={resetFilter}>
                  Reset
                </button>
              </div>
            </div>

            <ul className="nav nav-tabs mb-3">
              {tabs.map((t) => (
                <li key={t.key} className="nav-item">
                  <a
                    className={`nav-link ${tab === t.key ? "active" : ""}`}
                    onClick={() => {
                      setTab(t.key);
                      setPage(1);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {t.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="table-responsive">
              <table className="table table-bordered text-nowrap w-100">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Order ID</th>
                    <th>User</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Admin Reason</th>
                    <th>Sub Total</th>
                    <th>Delivery Charge</th>
                    <th>Net Amount</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan="10">
                        <Loader />
                      </td>
                    </tr>
                  ) : list.length ? (
                    list.map((row, i) => (
                      <tr key={row.id}>
                        <td>{(page - 1) * itemperpage + i + 1}</td>
                        <td>{row.order_number}</td>
                        <td>{row.user?.name || "N/A"}</td>
                        <td>{formateDateWithMonth(row.createdAt)}</td>
                        <td>{row.order_status}</td>
                        <td>{row.admin_cancel_reason || "-"}</td>
                        <td>₹{row.total_amount}</td>
                        <td>₹{row.shipping_amount}</td>
                        <td>₹{row.net_amount}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-info me-2"
                            onClick={() =>
                              navigate(`/admin/order/view/${row.id}`)
                            }
                          >
                            View
                          </button>
                          <button
                            className="btn btn-sm btn-secondary me-2"
                            title="View Tax Invoice"
                            onClick={() => {
                              if (row.invoice_pdf) {
                                window.open(row.invoice_pdf, "_blank");
                              } else {
                                orderServices.GetOrderInvoice(row.id).then((res) => {
                                  if (res && res.success && res.data?.invoice_url) {
                                    window.open(res.data.invoice_url, "_blank");
                                  } else {
                                    Swal.fire({
                                      icon: "error",
                                      text: (res && res.message) || "Failed to fetch invoice",
                                      ...SWAL_SETTINGS,
                                    });
                                  }
                                });
                              }
                            }}
                          >
                            📄 Invoice
                          </button>
                          {row.order_status?.toLowerCase() === "placed" && (
                            <button
                              className="btn btn-sm btn-primary me-2"
                              onClick={() =>
                                updateStatus(row.id, "Processing")
                              }
                            >
                              Process
                            </button>
                          )}
                          {row.order_status?.toLowerCase() === "processing" && (
                            <button
                              className="btn btn-sm btn-info me-2"
                              onClick={() => updateStatus(row.id, "Shipped")}
                            >
                              Ship
                            </button>
                          )}
                          {row.order_status?.toLowerCase() === "shipped" && (
                            <button
                              className="btn btn-sm btn-success me-2"
                              onClick={() => updateStatus(row.id, "Delivered")}
                            >
                              Deliver
                            </button>
                          )}
                          {["placed", "processing", "shipped", "pending"].includes(
                            row.order_status?.toLowerCase(),
                          ) && (
                              <button
                                className="btn btn-sm btn-danger me-2"
                                onClick={() => updateStatus(row.id, "Cancelled")}
                              >
                                Cancel
                              </button>
                            )}
                          {row.order_status?.toLowerCase() === "return_requested" && (
                              <>
                                <button
                                  className="btn btn-sm btn-warning me-2"
                                  onClick={() => updateStatus(row.id, "Returned")}
                                >
                                  Approve Return
                                </button>
                                <button
                                  className="btn btn-sm btn-secondary me-2"
                                  onClick={() => updateStatus(row.id, "return_rejected")}
                                >
                                  Reject Return
                                </button>
                              </>
                            )}
                          {/* {row.items.some(item => item.return_status === 'Requested') && (
                            <>
                              <button className="btn btn-sm btn-warning me-2" onClick={() => manageReturn(row._id, row.items.find(item => item.return_status === 'Requested').remedies_id, 'approve')}>
                                Approve Return
                              </button>
                              <button className="btn btn-sm btn-secondary me-2" onClick={() => manageReturn(row._id, row.items.find(item => item.return_status === 'Requested').remedies_id, 'reject')}>
                                Reject Return
                              </button>
                            </>
                          )}
                          {row.items.some(item => item.return_status === 'Approved') && (
                            <button className="btn btn-sm btn-success" onClick={() => manageReturn(row._id, row.items.find(item => item.return_status === 'Approved').remedies_id, 'process')}>
                              Process Return
                            </button>
                          )} */}
                          {/* {row.items.some(item => item.return_status === 'Requested' || item.return_status === 'Approved') && 
                          (<button className="btn btn-sm btn-warning me-2" onClick={() => navigate(`/admin/order/view/${row?._id}`)}>
                            Manage Return
                          </button>)
                          } */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10">No orders</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="mt-3">
              <b>Total Records: {datalength}</b>
            </div>
            {datalength > 0 && (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[{ name: "Orders", path: "/admin/order/list" }]}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderList;
